import useSound from "use-sound";
import applause from "@/assets/sounds/applause.mp3";

function useApplause() {
  const [play, { stop }] = useSound(applause, { interrupt: true });
  return { play, stop };
}

export default useApplause;
